import { State } from 'app/redux';

export const getSettingsCompany = (state: State) => state.settings.company;
export const getSettingsCompanyCountry = (state: State) =>
  state.settings.company.country;
